
export const EDITAR_CADASTRO = 'Editar Cadastro de Requisição';
export const NOVO_CADASTRO = 'Novo Cadastro de Requisição';
export const BUTTON_NEW = 'Novo';
export const REQUISICOES = 'Requisições ';
export const removalDialogMessage = name => `Deseja excluir a requisição ${name}?`;
